import { createSvgComponent } from "../../icon/createSvgComponent";
import FireFill from "@core/__generated__/icon/figma/fire-fill.svg";
export default createSvgComponent(FireFill);